export function clamp(value, minValue, maxValue) {
  if (minValue > maxValue) {
    throw new Error('最小值不能大于最大值');
  }
  return Math.max(minValue, Math.min(value, maxValue));
}

export function randomInRange(min, max) {
  return Math.random() * (max - min) + min;
}
/**
 * 生成随机范围数值
 */
export function randomRange(min, max) {
  return Math.random() * (max - min) + min;
}

export function randomRangeInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function fixedNumber(value, precision) {
  return Number(Number(value).toFixed(precision));
}
